document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.custom-hero-slider').forEach(function (slider) {
    var slides = slider.querySelectorAll('.custom-hero-slider__slide');
    if (slides.length < 2) return;

    var dots = slider.querySelectorAll('.custom-hero-slider__dot');
    var prevBtn = slider.querySelector('.custom-hero-slider__arrow--prev');
    var nextBtn = slider.querySelector('.custom-hero-slider__arrow--next');
    var current = 0;
    var autoplay = slider.dataset.autoplay === 'true';
    var speed = parseInt(slider.dataset.autoplaySpeed, 10) || 5000;
    var timer = null;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); restartAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restartAutoplay(); });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        restartAutoplay();
      });
    });

    function startAutoplay() {
      if (autoplay) {
        timer = setInterval(next, speed);
      }
    }

    function restartAutoplay() {
      if (timer) clearInterval(timer);
      startAutoplay();
    }

    startAutoplay();
  });
});